<template>
    <span>
        <button @click="goToReports()" class="text-center text-gray-600 hover:text-blue-500 pr-1 hidden md:block">
            <i class="uil uil-clipboard-notes text-2xl pr-3"></i>
            <span v-if="notificationCount && hasMessengerManagement" class="tasks-bubble">
                {{ notificationCount }}
            </span>
        </button>
        <span v-if="notificationCount && hasMessengerManagement" class="rounded-full bg-gray-600 h-4 py-0.5  px-1 text-xs text-white mr-2 md:hidden">
            {{ notificationCount }}
        </span>
    </span>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { subscriptions } from '@/store/subscriptionModule/helper'
export default {
    mounted() {
        this.initializeTaskSubscription();
    },
    computed: {
        ...mapState(['userTasks']),
        ...mapGetters(['hasMessengerManagement']),
        notificationCount() {
            return this.userTasks.length || 0
        },
    },
    methods: {
        goToReports() {
            if (this.$route.name !== 'Task') this.$router.push({ name: 'Task' })
        },
        initializeTaskSubscription() {
            if (subscriptions.task) {
                subscriptions.task.loadList();
                subscriptions.task.subscribe();
            }
        }
    },
    beforeDestroy() {
        if (subscriptions.task) {
            subscriptions.task.unsubscribe();
        }
    }
}
</script>